import * as React from "react";
import {inject, observer} from "mobx-react";
import {ClipsFullscreenStore} from "../../../../lib/ClipsFullscreenStore";

interface IAnonymControlWrapper extends React.PropsWithChildren {
    store?: ClipsFullscreenStore;
}

export const AnonymControlWrapper: React.FC<IAnonymControlWrapper> = inject("store")(observer(
    (props: IAnonymControlWrapper): React.ReactElement => {
        const store = props.store!;

        const [url, setUrl] = React.useState(store.anonymUrl);

        function handleClick() {
            setUrl(store.getRtuForAnonym());
        }

        return (
            (store.isAnonym && store.anonymUrl) ?
                <a href={url} className={"js-ajax-envelope-bmenu"} onClick={handleClick}>
                    {props.children}
                </a> :
                <>
                    {props.children}
                </>
        );
    }
));
